export type AtVirtualClinicGender =
  | 'M'
  | 'W'
  | 'X'
  | 'I'
  | 'O'
  | 'NA';

export const AT_VIRTUAL_CLINIC_GENDER_DISPLAY_NAMES: {
  [gender in AtVirtualClinicGender]: string;
} = {
  M: 'Männlich',
  W: 'Weiblich',
  X: 'Divers',
  I: 'Inter',
  O: 'Offen',
  NA: 'Unbekannt',
};
